import "../stylesheets/admin.scss";
import "../stylesheets/availability_visualisation.scss";

// Configure Stimulus
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "../controllers/register_controllers";

const application = Application.start();

const controllers = import.meta.glob("../controllers/{admin,shared}/**/*", { eager: true })
registerControllers(application, controllers);

import "../src/admin_cable";
import "../src/admin/google_auth_handler";

window.addEventListener('wheel', (event) => {
  if (event.target.type == 'number')
    event.target.blur();
});
